import { CtxBodyAbstract } from './ctx-body-abstract';
import { DescrittoreSezione } from './descrittore-sezione';
import { PraticaFull } from './pratica/pratica-full';

export class CtxBodyPratica extends CtxBodyAbstract {
  pratica: PraticaFull;
  constructor(descrittori: DescrittoreSezione[], pratica: PraticaFull) {
    super(descrittori);
    this.pratica = pratica;
  }
}
